import { useAccountModal, useSessionClient } from "@latticexyz/entrykit/internal";
import { useStash } from "@latticexyz/stash/react";
import { stash, tables } from "./stash";
import { getRecord } from "./getRecord";
import { enterArena, openArena } from "./actions";
import { useNavigate } from "react-router-dom";
import { Button } from "./Button";
import { useMatchTimeLeft } from "./useMatchTimeLeft";

export const JoinButton = () => {
  const { openAccountModal } = useAccountModal();
  const { data: client } = useSessionClient();
  const navigate = useNavigate();

  const currentMatch = useStash(stash, (state) => {
    const currentMatchId = getRecord({ state, table: tables.MatchCounter, key: [] })?.value;
    if (!currentMatchId) return undefined;
    return getRecord({ state, table: tables.Match, key: { id: currentMatchId } });
  });

  const matchConfig = useStash(stash, (state) => getRecord({ state, table: tables.MatchConfig, key: [] }));

  const matchTimeLeft = useMatchTimeLeft();

  if (!client) {
    return <Button label="Get ready" onClick={openAccountModal} />;
  }

  if (!matchConfig) {
    return <Button label="Waiting for match config" />;
  }

  console.log("current match", currentMatch);

  if (!currentMatch || matchTimeLeft === 0 || currentMatch.players.length === 0) {
    console.log({ currentMatch, matchTimeLeft });
    return <Button label="Create match" onClick={() => openArena(client, navigate)} />;
  }

  if (currentMatch.players.includes(client.account!.address)) {
    return <Button label="Enter arena" onClick={() => navigate("/arena")} />;
  }

  if (currentMatch.players.length < matchConfig.matchSize) {
    return <Button label="Join match" onClick={() => enterArena(client, navigate)} />;
  }

  return <Button label={`${matchTimeLeft}s until next match`} />;
};
